import { styled } from 'styled-system/jsx'

const FooterRegion = styled('footer', {
  base: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    paddingX: '24px',
    paddingBottom: '24px',
    paddingTop: '4px',
  },
})

const LegalLink = styled('a', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '600',
    color: 'quickpass.inkSoft',
    textDecoration: 'none',
    _hover: {
      color: 'quickpass.primary',
      textDecoration: 'underline',
      textUnderlineOffset: '3px',
    },
  },
})

const Separator = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: 'quickpass.inkSoft',
    opacity: '0.5',
  },
})

export { FooterRegion, LegalLink, Separator }
